import { UserPermissions } from "./UsersPermissions";

export const CheckSubModulesPermissions = (v) => {
  if (Array.isArray(v)) {
    var temp2 = false;
    v.forEach((i) => {
      const temp = UserPermissions[i];
      if (temp?.allotment && temp?.permission > 0) temp2 = true;
      return false;
    });
    return temp2;
  } else {
    return "error";
  }
};

export const checkOnlySubModulesAllotment = (v) => {
  if (Array.isArray(v)) {
    var temp2 = false;
    v.forEach((i) => {
      const temp = UserPermissions[i];
      if (temp?.allotment) temp2 = true;
      return false;
    });
    return temp2;
  } else {
    return "error";
  }
};
